import styles from "./PromoRow.module.scss";
import Section from "../common/Section.tsx";
import usePromoConfig from "../common/usePromoConfig.ts";
import NamedPromo from "../common/NamedPromo.tsx";

export default function PromoRow() {
  const { mainRow } = usePromoConfig();

  if (mainRow.length === 0) {
    return null;
  }

  return (
    <Section gridClassName={styles.grid}>
      {mainRow.map((name) => (
        <NamedPromo
          name={name}
          key={name}
          className={name === "big" ? styles.big : styles.little}
        />
      ))}
    </Section>
  );
}
